import { takeLatest, put, call } from 'redux-saga/effects';

import { findAllVeiculoCadastro } from '../service';
import {
  LIST_VEICULO_CADASTRO,
  LIST_VEICULO_CADASTRO_PENDING,
  LIST_VEICULO_CADASTRO_SUCCESS,
  LIST_VEICULO_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListAllVeiculoCadastro(action) {
  yield put({ type: LIST_VEICULO_CADASTRO_PENDING })

  try {
    const list = yield call(findAllVeiculoCadastro)
    
    yield put({ type: LIST_VEICULO_CADASTRO_SUCCESS, list: list })
  } catch (error) {

    yield put({ type: LIST_VEICULO_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListAllVeiculoCadastro() {
  yield takeLatest(LIST_VEICULO_CADASTRO, sagaListAllVeiculoCadastro)
}